export const getHasUnframed = (items: any) => {
  return (
    items.filter((item) => item.sku === 'P12X16').length > 0 ||
    items.filter((item) => item.sku === 'P18X24').length > 0 ||
    items.filter((item) => item.sku === 'P24X36').length > 0 ||
    items.filter((item) => item.sku === 'P18X24-6000').length > 0
  );
};
